import { Skeleton } from "@mui/material";
import { useRouter } from "next/router";
import { useTheme } from "@/contexts/theme";
import { isReportScreen } from "@/themes/modern/hubs";
import { useStyle } from "./style";
import { getTitleTypography } from "@/utils/typography-utils";

const HeaderTitle = ({ marginTop, marginBottom, color, ...props }: any) => {
  const { classes } = useStyle({ marginTop, marginBottom });
  const { currentTheme } = useTheme();
  const router = useRouter();
  // The modern top bar already shows the page name on report screens.
  if (currentTheme === "modern" && isReportScreen(router.pathname)) {
    return null;
  }

  return (
    <div style={classes.container}>
      {props?.title?.length > 0 ? (
        <div style={getTitleTypography({ color })}>{props.title}</div>
      ) : (
        <Skeleton variant="text" sx={{ fontSize: "2rem", width: "20%" }} />
      )}
    </div>
  );
};
export { HeaderTitle };
